import { SeasonalMenuPanels } from './SeasonalMenuPanels';

export default SeasonalMenuPanels;
